export default "__VITE_ASSET__tz1r4VHR__"